const AppConstants = {
    //API_BASE_URL: "http://localhost:5000/api",
    //API_BASE_URL: "http://www.cloudportal.co.uk/o2logs/api",    
    API_BASE_URL: "https://logs-live.o2-cloudportal.co.uk/api",
 }

export default AppConstants;


